import { Box, CircularProgress } from '@mui/material';

export default function ScreenLoader() {
  return (
    <Box display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'} height={'100%'}>
      <CircularProgress />
    </Box>
  );
}
